export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth',
  },
  // {
  //   action: 'read',
  //   subject: 'LoggedIn',
  // },
]

export const _ = undefined
